// Blog post images - properly imported for Vite bundling
import blogBestGrassTexas from '@/assets/blog-best-grass-texas.jpg';
import blogMulchVsRock from '@/assets/blog-mulch-vs-rock.jpg';
import blogSodDelivery from '@/assets/blog-sod-delivery.jpg';
import blogTopsoilGuide from '@/assets/blog-topsoil-guide.jpg';
import blogSpringLawnCare from '@/assets/blog-spring-lawn-care.jpg';
import blogStAugustineGuide from '@/assets/blog-st-augustine-guide.jpg';
import blogBermudaGrass from '@/assets/blog-bermuda-grass.jpg';
import blogZoysiaPremium from '@/assets/blog-zoysia-premium.jpg';
import blogSodTiming from '@/assets/blog-sod-timing.jpg';

export const blogImages = {
  'best-grass-for-texas-heat': blogBestGrassTexas,
  'mulch-vs-rock-landscaping': blogMulchVsRock,
  'sod-delivery-near-me': blogSodDelivery,
  'topsoil-calculator-guide': blogTopsoilGuide,
  'spring-lawn-care-checklist': blogSpringLawnCare,
  'st-augustine-grass-texas-guide': blogStAugustineGuide,
  'bermuda-grass-texas-lawns': blogBermudaGrass,
  'zoysia-grass-premium-lawns': blogZoysiaPremium,
  'when-to-install-sod-texas': blogSodTiming,
} as const;

export type BlogImageKey = keyof typeof blogImages;

export const getBlogImage = (slug: string): string => {
  return blogImages[slug as BlogImageKey] || blogBestGrassTexas;
};
